export default __webpack_public_path__ + "static/cafeteriua-d659e72eac9f7b3ad52e993d8e9d100b.gif";